import {TAB_SELECTED, TAB_NEW, TAB_DELETE} from "./tabsConstants";

export function selectTab(tabName) {
    return {
        type : TAB_SELECTED,
        payload : {tabName},
    };
}

export function newTab(tabName) {
    return {
        type : TAB_NEW,
        payload : {tabName},
    };
}
